import {ListTariffPlans} from './list-tariff-plans';

export default ListTariffPlans;